import { render, staticRenderFns } from "./ModalViagemInfos.vue?vue&type=template&id=733072c6"
import script from "./ModalViagemInfos.vue?vue&type=script&lang=js"
export * from "./ModalViagemInfos.vue?vue&type=script&lang=js"
import style0 from "./ModalViagemInfos.vue?vue&type=style&index=0&id=733072c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports